
import { Avatar } from "@/components/ui/avatar";

export const TestimonialsSection = () => {
  const testimonials = [
    {
      quote: "I sold out my event in 48 hours using the AI marketing features!",
      author: "Sarah J.",
      role: "Event Promoter",
      company: "NocheTonto Events"
    },
    {
      quote: "The QR code system made entry management a breeze. No more paper lists!",
      author: "Mike R.",
      role: "Club Promoter",
      company: "Pulse Entertainment"
    }
  ];

  return (
    <div className="py-24 px-6 bg-black/50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-16">
          Trusted by Top Promoters
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="p-8 rounded-xl bg-gray-900 border-2 border-purple-500/30 shadow-[0_0_30px_rgba(168,85,247,0.15)]"
            >
              <div className="flex items-center gap-4 mb-6">
                <Avatar className="h-16 w-16 border-2 border-purple-500/30" />
                <div>
                  <h3 className="font-semibold text-white">{testimonial.author}</h3>
                  <p className="text-sm text-gray-400">{testimonial.role}</p>
                  <p className="text-sm text-purple-400">{testimonial.company}</p>
                </div>
              </div>
              <blockquote className="text-xl text-gray-300">
                "{testimonial.quote}"
              </blockquote>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
